import React from 'react';
import PanelMeasure from '@/layout/components/PanelMeasure';
import RequestsPanelFull from '../containers/RequestsPanelFull';
import RequestsPanelNarrow from '../containers/RequestsPanelNarrow';

const RequestsPanel = ({ configuration }) => (
  <PanelMeasure
    configuration={configuration}
    component={{ full: RequestsPanelFull, narrow: RequestsPanelNarrow }}
  />
);

export default RequestsPanel;
